import {List} from 'immutable';
import {AContent} from "../base.content";
import {CMSContentType} from "../CMSType";

export interface BaseListContentParams<T> {
  items?: T[];
}

export abstract class BaseListContent<T> extends AContent {
  public readonly items: List<T>;

  constructor(type: CMSContentType, data: BaseListContentParams<T> = {items: []}) {
    super(type);
    this.items = List(data.items);
  }

  updateList(newList: List<T>) {
    return this._merge({items: newList});
  }

  includes(item: T): boolean {
    return this.items.includes(item);
  }

  push(item: T): this {
    return this.updateList(this.items.push(item));
  }

  remove(item: T): this {
    return this.updateList(this.items.delete(this.items.indexOf(item)));
  }

  updateListItem(oldItem: T, newItem: T): BaseListContent<T> {
    return this.updateList(this.items.set(this.items.indexOf(oldItem), newItem));
  }

  move(oldIndex: number, newIndex: number): BaseListContent<T> {
    return this.updateList(List(this.items.toArray().reduce((prevValue, value, index, base) => {
      if (index !== oldIndex) {

        if (index === newIndex && oldIndex > newIndex) {
          prevValue.push(base[oldIndex]);
        }

        prevValue.push(value);

        if (index === newIndex && oldIndex < newIndex) {
          prevValue.push(base[oldIndex]);
        }
      }

      return prevValue;
    }, [])));
  }

  public toJSON() {
    return Object.assign(super.toJSON(), {
      items: this.items.toArray()
    });
  }
}



// WEBPACK FOOTER //
// ./src/api/club-cms/content/list.abstract.content.ts